import { Center, Flex, Text } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';
import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  step: number;
  hasFormFields?: boolean;
}

const ConnectBrokerInstructionItem: FC<Props> = ({ step, children, hasFormFields = false }) => {
  return (
    <Flex alignItems={hasFormFields ? 'flex-start' : 'center'} fontWeight={700}>
      <Center
        borderRadius="50%"
        backgroundColor={Color.Primary500}
        mr="82px"
        w="38px"
        h="38px"
        minW="38px"
        minH="38px"
      >
        <Text fontSize={FontSize.lg} color={Color.OnPrimary}>
          {step}
        </Text>
      </Center>
      {children}
    </Flex>
  );
};

export default ConnectBrokerInstructionItem;
